(function () {
    'use strict';

    angular
        .module('invoices')
        .controller('EditInvoiceModalController', EditInvoiceModalController);

    EditInvoiceModalController.$inject = ['$uibModalInstance', '$timeout','InvoicesService', 'invoice', 'getInvoices','InvoicePaymentFeeService', 'toastr'];

    function EditInvoiceModalController($uibModalInstance, $timeout, InvoicesService, invoice, getInvoices, InvoicePaymentFeeService, toastr) {
        var vm = this;
        vm.invoice                  = invoice;
        vm.getInvoices              = getInvoices;
        vm.categoryList             = [];
        vm.invoicesAccountSelected  = [];
        vm.invoicesAccountList      = '';
        vm.invoicesPaymentsList     = '';
        vm.invoicesFee               = [];
        vm.feeAmount                 = '';
        vm.feeCategorySelected       = {id:11, name:'Overhead', parent_id:null};
        vm.feeAccountSelected        = {id:35, name:'Wire Transfer Fee income', sub_type:'ServiceFeeIncome',classification:'Revenue',  parent_id:null};
        vm.invoicesPaymentsFees      = [];
        vm.isAllSelected            = false;
        vm.getInvoicePaymentHistory = getInvoicePaymentHistory;
        vm.save                     = save;
        vm.cancel                   = cancel;
        vm.optionToggled            = optionToggled;
        vm.toggleAll                = toggleAll;
        vm.getCostCenterCategory    = getCostCenterCategory;
        vm.getInvoicesAccount       = getInvoicesAccount;
        vm.getFees                  = getFees;
        vm.addFees                  = addFees;
        vm.removeFee                = removeFee;


        activate();

        function activate() {
            vm.getInvoicePaymentHistory();
            vm.getCostCenterCategory();
            vm.getInvoicesAccount();
        }

        function getInvoicePaymentHistory() {
            if(vm.invoice.id) {
                InvoicesService.getInvoicePaymentHistory(vm.invoice.id).then(function (response) {
                    vm.invoicesPaymentsList = response.data.map(function(item){
                        item.selected = false;
                        return item;
                    });
                }).catch(function (err) {
                });
            }
        }

        function optionToggled(invoiceHistory) {
            invoiceHistory.show = !invoiceHistory.show;
            if (invoiceHistory.show) {
                vm.getFees(invoiceHistory);
            }
            vm.isAllSelected = vm.invoicesPaymentsList.every(function(itm){ return itm.selected; })
        }

        function toggleAll() {
            var toggleStatus = vm.isAllSelected;
            angular.forEach(vm.invoicesPaymentsList, function(itm){ 
                itm.selected = toggleStatus;
                itm.show = toggleStatus;
            });
        }

        function save() {
            var query = {};
            query.item = JSON.stringify(vm.invoicesPaymentsList);
            query.invoice = vm.invoice;
            InvoicesService.editInvoicePayment(query).then(function(response) {
                toastr.success('Successfully saved!');
                vm.getInvoicePaymentHistory();
            }).catch(function(err) {
            });
            
        }

        function cancel() {
            $uibModalInstance.close();
            vm.getInvoices();
        }

        function getCostCenterCategory() {
            InvoicesService.getInvoicesCostCenterCategory().then(function(response) {
                vm.categoryList = response.data;
            }).catch(function(err) {
            });
        }

        function getInvoicesAccount() {
            InvoicesService.getInvoicesAccount().then(function(response) {
                    vm.invoicesAccountList = response.data;
            }).catch(function(err) {
            });
        }

        function addFees(invoiceHistory) {
            var query = {
                        'amount': vm.feeAmount,
                        'invoice_payment_id': vm.invoice.id,
                        'cost_center': vm.feeCategorySelected,
                        'fin_cost_center_id': vm.feeCategorySelected.id,
                        'account': vm.feeAccountSelected,
                        'fin_account_id': vm.feeAccountSelected.id,
                        'currency_code_received': vm.invoice.currency_code_received,
                        'currency_code_invoice': vm.invoice.currency,
                        'exchange_rate': vm.invoice.exchange_rate
                        };                      
            if (typeof invoiceHistory.invoicesFee === 'undefined') {
                invoiceHistory.invoicesFee = [];
            }   
            invoiceHistory.invoicesFee.push(query);   
            vm.feeAmount = '';
        }

        function removeFee(invoiceHistory, item) {
            invoiceHistory.invoicesFee.splice(invoiceHistory.invoicesFee.indexOf(item), 1);
        }

        function getFees(invoiceHistory) {
            var query = {};
            query['invoice_payment_id'] = invoiceHistory.id;
            InvoicePaymentFeeService.getFees(query).then(function(response) {
                invoiceHistory.invoicesFee = response.data;
            }).catch(function(err) {
            });
        }
    }

})();